export const getInitials = (name, me) => {
  const theName = name ? name : `${!me ? "Shopper " : ""} Undefined`;
  return theName
    .split(" ")
    .map((n) => n[0])
    .join("");
};
